export default "{\n    \"label\": \"{{name}}\",\n    \"label_0\": \"Plan Type\",\n    \"label_plural\": \"{{count}} Plan Types\"\n}\n"